import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const togglePaymentCardsButtonStyles = {
  button: {
    width: '100%',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.button.primary,
    transition: `color ${theme.transitions.fast}`,
  } as CSSProperties,
};
